/* eslint-disable import/imports-first */
// istanbul ignore next
import React from 'react'
import ReactDOM from 'react-dom'
import firebase from 'firebase'
import { Provider } from 'react-redux'
import store from './store'
import 'whatwg-fetch'

// metronic font (Open Sans)
import 'opensans-npm-webfont' // eslint-disable-line import/extensions

// metronic bundled bootstrap css
import 'theme/plugins/bootstrap/css/bootstrap.css'
import 'theme/plugins/font-awesome/css/font-awesome.css'
import 'bootstrap-social' // eslint-disable-line

// metronic css
import 'theme/layouts/layout3/css/layout.min.css'
import 'theme/layouts/layout3/css/themes/default.min.css'
import 'theme/css/components-rounded.css'
import 'theme/css/plugins.css'

// global project css
import './index.css'

import 'theme/plugins/bootstrap/js/bootstrap.min'

import Routes from './routes'

// Initialize Firebase
// istanbul ignore next
const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_ID
}
// istanbul ignore next
firebase.initializeApp(config)
// istanbul ignore next
ReactDOM.render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js